import type { SrInsightType } from '@plato/data/starrocks/types';
import { opportunityInsightTypes, riskInsightTypes } from '@plato/insights/context';

/**
 * Whether an insight belongs in the "Risks" section rather than "Opportunities".
 *
 * Delegates to the service layer's `riskInsightTypes` so the card bucketing, the customer-list
 * `insight_sum_risk` aggregates and the Team page "Revenue at Risk" can never disagree.
 */
export function isRiskInsightType(type: SrInsightType): boolean {
    return (riskInsightTypes as readonly string[]).includes(type);
}

/**
 * Whether an insight's money figure is a potential (a ceiling) rather than a measured decline.
 * Not `!isRiskInsightType`: a type in neither bucket is neither, and gets the plain signed delta.
 */
export function isOpportunityInsightType(type: SrInsightType): boolean {
    return (opportunityInsightTypes as readonly string[]).includes(type);
}
